var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    (_vm.$session.type === 'account' || _vm.$session.permissions.is('SHOW_ALL_MENUS')) && _vm.show
  )?_c('el-button',{staticClass:"batch-operate-btn",attrs:{"type":"text","data-matomo":_vm.$store.state.matomo[20].id},on:{"click":_vm.editVd}},[_vm._v(" "+_vm._s(_vm.$t("vdcontainer.modification"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }